import React from 'react';
import { Select } from '@amzn/awsui-components-react-v3';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';

export class SavedReportsButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: this.props.text,
      empty: false,
    };
  }

  pullReportsFromJson = (reportsList) => {
    this.selectOptions = [];
    if (reportsList.length && this.state.empty) {
      this.setState({ text: this.props.text, empty: false });
    }
    if (!(this.props.loading || this.state.empty || reportsList.length)) {
      this.setState({ text: 'No Reports Found', empty: true });
    }
    for (let report of reportsList) {
      let dropdownItem = {};
      dropdownItem['value'] = report['id'];
      dropdownItem['label'] = report['name'];
      this.selectOptions.push(dropdownItem);
    }
    return this.selectOptions;
  };

  render() {
    let options = this.pullReportsFromJson(this.props.reportsList);
    return (
      <div id="saved-reports" className={AccuracyButtonNewStyle}>
        <b> {this.props.text} </b>
        <Select
          options={options}
          label={this.props.text}
          placeholder={this.state.text}
          onChange={this.props.onChange}
          loading={this.props.loading}
          loadingText={'Fetching Reports...'}
          filteringType={'auto'}
          disabled={this.state.empty}
          data-cy={this.props['data-cy']}
        />
      </div>
    );
  }

  static defaultProps = {
    'data-cy': 'saved-reports-button'
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/saved_reports_button.jsx